<template>
  <div class="bs-table-table">
    <v-row no-gutters>
      <employee-group-form
        v-if="isGroupCreation || selectedGroupItem"
        :selectedGroup="selectedGroupItem"
        @groupUpdated="updateGroup"
      />
      <v-col v-else class="col-without-top-padding table-color">
        <v-data-table
          class="bs-table elevation-0"
          :headers="headers"
          :items="groups"
          :server-items-length="totalGroups"
          :multi-sort="false"
          :must-sort="true"
          calculate-widths
          :options.sync="options"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <edit-icon @click="editGroup(item)" v-on="on" v-bind="attrs" class="mr-1 icon-control-list"/>
              </template>
              <span>{{ $t(`components.employeeList.tooltips.editGroup`) }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <delete-icon @click="$emit('deleteEmployeeGroupClick', item)" v-on="on" v-bind="attrs" v-if="!item.isDefault" class="mr-1 icon-control-list"/>
              </template>
              <span>{{ $t(`components.employeeList.tooltips.deleteGroup`) }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="d-flex justify-between align-center py-2 px-4 bs-table-footer">
          <v-row no-gutters class="bs-per-page">
            <span>
              {{ $t(`global.perPage`) }}
            </span>
            <span
              v-for="item  in [10, 20, 30]"
              :key="item"
              class="px-1"
              :class="{ 'active-page-count': item === options.itemsPerPage }"
              @click="options.itemsPerPage = item"
            >
              {{ item }}
            </span>
          </v-row>
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            color="#f2f2f2"
            class="bs-pagination"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { iconLoader } from '@/helpers/iconsLoader';
import EmployeeGroupForm from '../EmployeeGroupForm.vue';

export default {
  name: 'EmployeeGroupsList',
  components: {
    ...iconLoader.elements,
    EmployeeGroupForm,
  },
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    totalGroups: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      options: {},
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      isGroupCreation: false,
      selectedGroupItem: null,
    };
  },
  watch: {
    options: {
      handler() {
        this.$emit('options', this.options);
      },
      deep: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('components.employeeList.list.groupName'),
          align: 'left',
          sortable: false,
          value: 'name',
          class: 'text-uppercase',
        },
        {
          value: 'action',
          width: '10%',
          sortable: false,
          align: 'end',
        },
      ];
    },
  },
  methods: {
    async editGroup(item) {
      this.isGroupCreation = true;
      const { data } = await this.$store.dispatch('employee/getEmployeeGroup', item.id);
      this.selectedGroupItem = data;
    },
    updateGroup() {
      this.isGroupCreation = false;
      this.$emit('updateGroup');
    },
    toggleGroupCreation() {
      this.isGroupCreation = !this.isGroupCreation;
    },
  },
};
</script>
